import SearchBarWMagnifier from './SearchBarWMagnifier';

export default SearchBarWMagnifier;
